module.exports = __webpack_public_path__ + "img/wkdthg-light.f6f604d4.png";